import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/tableConstants/API";

interface UploadState {
  data: any;
  loading: boolean;
}

const initialState: UploadState = {
  data: [],
  loading: false,
};

export const PostExistingKddPreviewReducer = createAsyncThunk(
  "existingPreview/post",
  async (fileName:any, thunkAPI) => {
    try {
      const response = await axios.post(`${API.PostPreviewExistingData}`, fileName);
      return response.data;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(
        err.response.data || "Something went wrong."
      );
    }
  }
);
export const PostExistingAsapReducer = createAsyncThunk(
  "PostExistingAsapReducer/post",
  async (fileName:any, thunkAPI) => {
    try {
      const response = await axios.post(`${API.PreviewExistingAsapData}`, fileName);
      return response.data;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(
        err.response.data || "Something went wrong."
      );
    }
  }
);

const ExistingPreviewReducer = createSlice({
  name: "ExistingPreviewReducer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(PostExistingKddPreviewReducer.pending, (state) => {
        state.loading = true;
      })
      .addCase(PostExistingKddPreviewReducer.fulfilled, (state, action) => {
        state.data = action.payload;
        console.log(action.payload,'action.payload')
        state.loading = false;
      })
      .addCase(PostExistingKddPreviewReducer.rejected, (state, action) => {
        state.loading = false;
        console.error("Error in ExistingPreviewReducer:", action.payload);
      }) .addCase(PostExistingAsapReducer.pending, (state) => {
        state.loading = true;
      })
      .addCase(PostExistingAsapReducer.fulfilled, (state, action) => {
        state.data = action.payload;
        console.log(action.payload,'action.payload')
        state.loading = false;
      })
      .addCase(PostExistingAsapReducer.rejected, (state, action) => {
        state.loading = false;
        console.error("Error in ExistingPreviewReducer:", action.payload);
      });
  },
});
export const {} = ExistingPreviewReducer.actions;
export default ExistingPreviewReducer.reducer;
